import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAoMudarEtapa } from "./useAoMudarEtapa";

const API = "/api";
// Fica em 1 minuto: o resumo soma todos os módulos (Mesas, Balcão…), e venda
// que não passa pela lista da tela Delivery só aparece por aqui.
const INTERVALO_MS = 60000;

// `carregado`: false até a 1ª leitura voltar (com ou sem sucesso) — o resumo
// mostra cinza em vez de "0 pedidos · R$ 0,00" antes da hora.
const VAZIO = { pedidosHoje: 0, faturamentoHoje: 0, tempoMedioHoje: 0, carregado: false };

/**
 * Pedidos, faturamento e tempo médio de hoje (GET /pedidos/stats, fuso BRT) para
 * o ResumoDoDia. Relê a cada minuto e também quando um pedido da tela entra,
 * muda de etapa ou é concluído.
 */
export function useResumoDoDia(assinatura = null) {
  const [resumo, setResumo] = useState(VAZIO);
  const vivo = useRef(true);

  const buscar = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`${API}/pedidos/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (vivo.current && data) {
        setResumo({
          pedidosHoje: data.pedidosHoje || 0,
          faturamentoHoje: data.faturamentoHoje || 0,
          tempoMedioHoje: data.tempoMedioHoje || 0,
          carregado: true,
        });
      }
    } catch (_) {
      // Mantém a última leitura (na 1ª, sai do cinza com os zeros).
      if (vivo.current) setResumo((r) => (r.carregado ? r : { ...r, carregado: true }));
    }
  }, []);

  useEffect(() => {
    vivo.current = true;
    buscar();
    const t = setInterval(buscar, INTERVALO_MS);
    return () => { vivo.current = false; clearInterval(t); };
  }, [buscar]);

  useAoMudarEtapa(assinatura, buscar);

  return resumo;
}
